import type { PaginatedResult } from './common';
import type { JobError } from './job';

export enum JobTaskStatus {
  PENDING = 'pending',
  QUEUED = 'queued',
  RUNNING = 'running',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
  CANCELLING = 'cancelling',
  CANCELLED = 'cancelled',
}

export interface JobTaskError extends JobError {
  attempt: number;
}

export interface JobTask {
  _id: string;
  jobId: string;
  accountId: string;
  type: string;
  origin: string;
  status: JobTaskStatus;
  payload: Record<string, unknown>;
  attempt: number;
  error?: JobTaskError;
  metadata: Record<string, unknown>;
  createdAt: string;
  updatedAt: string;
  startedAt?: string;
  finishedAt?: string;
}

export type ListJobTasksResponse = PaginatedResult<JobTask>;
